import { fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { serviceOperationActions } from '../../actions/actionType/services/ServiceOperationActionType';
import {
  addServiceOperation,
  clearServiceOperationList,
  deleteServiceOperation,
  updateServiceOperation
} from '../../actions/sagaActions/services/ServiceOperationsSagaActions';
import {
  AddServiceOperationsRequest,
  DeleteServiceOperationsRequest,
  UpdateServiceOperationsRequest
} from '../../actions/types/services/ServiceOperationTypes';
/**
 * Saga to add service operation data list
 * @param requestObject:AddServiceOperationsRequest
 */
export function* addServiceOperationData({
  serviceOperationsList
}: AddServiceOperationsRequest) {
  yield put(addServiceOperation(serviceOperationsList));
}

function* addServiceOperationSaga() {
  yield takeEvery(
    serviceOperationActions.SAVE_SERVICE_OPERATIONS,
    addServiceOperationData
  );
}

/**
 * Saga to clear service operation list
 */
export function* clearServiceOperationData() {
  yield put(clearServiceOperationList());
}

export function* clearServiceOperationDataSaga() {
  yield takeLatest(
    serviceOperationActions.CLEAR_SERVICE_OPERATIONS,
    clearServiceOperationData
  );
}

/**
 * Delete service operation
 * @param index : number
 */
export function* deleteServiceOperationData({
  index
}: DeleteServiceOperationsRequest) {
  yield put(deleteServiceOperation({ indexNumber: index, statusMsg: 'deleted' }));
}

export function* deleteServiceOperationDataSaga() {
  yield takeLatest(
    serviceOperationActions.DELETE_SERVICE_OPERATION,
    deleteServiceOperationData
  );
}

/**
 * Updates service operation
 * @param data : payload
 */
export function* updateServiceOperationData({
  data
}: UpdateServiceOperationsRequest) {
  yield put(updateServiceOperation(data));
}

export function* updateServiceOperationDataSaga() {
  yield takeLatest(
    serviceOperationActions.UPDATE_SERVICE_OPERATION,
    updateServiceOperationData
  );
}

export const addServiceOperationDataSaga = [fork(addServiceOperationSaga)];
export const clearServiceOperationSaga = [fork(clearServiceOperationDataSaga)];
export const deleteServiceOperationSaga = [fork(deleteServiceOperationDataSaga)];
export const updateServiceOperationSaga = [fork(updateServiceOperationDataSaga)];
